export const isIterable = (obj: Iterable<unknown>): boolean => {
	if (obj == null) {
		return false;
	}
	return typeof obj[Symbol.iterator] === 'function';
};
